// Central site configuration for Hotel Gill Tower.
export const WHATSAPP_NUMBER = "919414877717";

export const HOTEL = {
  name: "Hotel Gill Tower",
  tagline: "Hotel · Hanumangarh, Rajasthan",
  addressLine1: "J75V+2XG, Sindhi Colony",
  addressLine2: "Hanumangarh, Rajasthan 335512, India",
  fullAddress: "J75V+2XG, Sindhi Colony, Hanumangarh, Rajasthan 335512, India",
  mapsUrl:
    "https://www.google.com/maps/search/?api=1&query=Hotel+Gill+Tower+J75V%2B2XG+Sindhi+Colony+Hanumangarh+Rajasthan+335512",
};

export const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  "Hello Hotel Gill Tower, I would like to book a room."
)}`;

export const ROOMS = [
  {
    id: 1,
    name: "Double Room with Sofa Lounge",
    price: 1785,
    image: "/images/room5a.jpg",
    alt: "Double bed and sofa lounge at Hotel Gill Tower, Hanumangarh",
  },
  {
    id: 2,
    name: "Twin Bed Room (AC)",
    price: 1785,
    image: "/images/room4.jpg",
    alt: "Twin bed room with air conditioning at Hotel Gill Tower, Hanumangarh",
  },
  {
    id: 3,
    name: "Budget Room (2 Single Beds)",
    price: 300,
    image: "/images/room3.jpg",
    alt: "Bright budget room with two single beds at Hotel Gill Tower, Hanumangarh",
  },
  {
    id: 4,
    name: "Double Room with AC & TV",
    price: 2000,
    image: "/images/room2.jpg",
    alt: "Double room with air conditioning and television at Hotel Gill Tower, Hanumangarh",
  },
  {
    id: 5,
    name: "Family Room (3 Beds)",
    price: 2626,
    image: "/images/room1.jpg",
    alt: "Family room with three beds at Hotel Gill Tower, Hanumangarh",
  },
];

export const HERO_IMAGE = ROOMS[3].image;

export const formatPrice = (n) => `₹${n.toLocaleString("en-IN")}`;
